import apiClient, { apiOpenClient, apiClientAdm } from '@/services/axios'

export const getChannelWarehouse = ({ business_id, channel_code, channel_id, connected }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  const path1 = connected ? 'map/' : ''
  const path2 = channel_code.includes('blibli') ? 'channel' : `${path1}list`
  const integrationUrl = channel_code.includes('lazada')
    ? `${channel_id}/warehouse`
    : `integration/query/warehouse/${path2}/${channel_id}`
  const url = channel_code.includes('shopee')
    ? `/channel/${channelPath}/query/warehouse/${channel_id}`
    : `/channel/${channel_code}/${integrationUrl}`

  return apiClient({
    method: 'get',
    url,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getChannelCategories = ({ business_id, workspace_id, channel_code, channel_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url:`/channel/${channelPath}/product/query/${channel_id}/categories`,
    headers: {
      'Business-Id': business_id,
      ...(workspace_id ? { 'Workspace-Id': workspace_id } : {}),
    },
    params: { business_id },
  })
}

export const getChannelAttributes = ({ business_id, channel_code, channel_id, channel_type, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/${channel_type}`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const channelEventProcess = ({ business_id, channel_code, channel_id, request_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/response/${request_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const channelImageDraft = ({ business_id, channel_code, channel_id, user_id, product_id, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/${user_id}/draft/images/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const checkStatusSyncOrderChannel = ({ business_id, channel_code, channel_id }) => {
  if (['shopee_id'].includes(channel_code)) {
    return apiClient({
      method: 'get',
      url: `/channel/shopee/v2/order/query/synchronize/${channel_id}/status`,
      headers: {
        'Business-Id': business_id,
      },
    })
  } else if (['lazada_id'].includes(channel_code)) {
    return apiClient({
      method: 'get',
      url: `/channel/${channel_code}/order/${channel_id}/synchronize/status`,
      headers: {
        'Business-Id': business_id,
      },
    })
  } else {
    return false
  }
}

export const getWarehouseChannelList = ({ sales_channel, channel_id }) => {
  let channelPath = sales_channel
  if (['shopee', 'shopee_id'].includes(sales_channel)) channelPath = 'shopee/v2'
  let url = `/channel/${channelPath}/integration/query/warehouse/list/${channel_id}`
  if (['tiktok', 'tiktok_id'].includes(sales_channel)) {
    url = `/channel/${sales_channel}/shop/query/${channel_id}/warehouse`
  }
  return apiClient({
    method: 'get',
    url,
  })
}

export const getConnectedWarehouseChannelList = ({ sales_channel, channel_id, business_id }) => {
  let channelPath = sales_channel
  if (['shopee', 'shopee_id'].includes(sales_channel)) channelPath = 'shopee/v2'
  const url = sales_channel === 'blibli' ? 'channel' : 'list'
  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/integration/query/warehouse/${url}/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const channelSyncProcess = ({ business_id, channel_code, channel_id, request_id }) => {
  let syncUrl = 'sync'
  if (channel_code.includes('blibli')) syncUrl = 'request'
  else if (channel_code === 'lazada_id') syncUrl = 'synchronize/status'
  else if (['tiktok', 'tiktok_id'].includes(channel_code)) syncUrl = 'process'

  const queryPath = channel_code === 'lazada_id' ? '' : '/query'

  let channelPath = channel_code
  if (channel_code.includes('blibli')) channelPath = 'blibli'
  else if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'

  return apiClient({
    method: 'get',
    url:  `/channel/${channelPath}/product${queryPath}/${channel_id}/${syncUrl}/${request_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getCatalogByMaster = ({ signal, business_id, channel_code, channel_id, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    signal,
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/catalogs`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getDetailProductChannel = ({ business_id, workspace_id, channel_code, channel_id, product_id }) => {
  let url = `/channel/${channel_code}/product/query/${channel_id}/${product_id}`

  if (channel_code === 'shopee_id') {
    url = `/channel/shopee/v2/product/query/${channel_id}/details/${product_id}`
  } else if (channel_code === 'blibli_id') {
    url = `/channel/blibli/product/query/${product_id}/${channel_id}`
  } else if (channel_code === 'toco_id') {
    url = `/channel/toco/product/query/${channel_id}/details/${product_id}`
  }

  return apiClient({
    method: 'get',
    url,
    headers: {
      'Business-Id': business_id,
      ...(workspace_id ? { 'Workspace-Id': workspace_id } : {}),
    },
  })
}

export const getProductChannelStatus = ({ channel_code, channel_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: `channel/${channelPath}/product/query/${channel_id}/status`,
  })
}

export const getProductConfirm = ({ channel_code, channel_id, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: `channel/${channelPath}/product/query/${channel_id}/catalog`,
    params,
  })
}

export const getCancelReason = ({ business_id, channel_code, params }) => {
  let url = `/channel/${channel_code}/order/query/cancellation-reasons`
  if (['shopee', 'shopee_id'].includes(channel_code)) {
    url = '/channel/shopee/v2/order/query/cancellation-reasons'
  }

  return apiClient({
    method: 'get',
    url,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getCmCancelReason = ({ business_id, order_number }) => {
  return apiClient({
    method: 'get',
    url: `/sales-manual/cancellation-reasons?order_number=${order_number}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncProductChannel = ({ business_id, channel_code, channel_id, user_id, channel_product_id, data }) => {
  const productId = channel_product_id
    ? `/${channel_product_id}`
    : ''

  let url

  if (['blibli', 'tiktok', 'zalora_id'].includes(channel_code)) {
    url = `/channel/${channel_code}/product/cmd/${channel_id}/sync${productId}`
  } else if (channel_code === 'lazada_id') {
    url = `/channel/${channel_code}/product/${channel_id}/synchronize${productId}`
  } else if (['shopee', 'shopee_id'].includes(channel_code)) {
    url = `/channel/shopee/v2/product/cmd/${channel_id}/sync${productId}`
  } else if (['toco', 'toco_id'].includes(channel_code)) {
    url = `/channel/toco/product/cmd/${channel_id}/sync${productId}`
  } else {
    url = `/channel/${channel_code}/product/cmd/${channel_id}/${user_id}import${productId}`
  }

  return apiClient({
    method: 'post',
    url,
    headers: {
      'Business-Id': business_id,
    },
    data,
    notifications: true,
  })
}

export const mappingProductChannel = ({ business_id, channel_code, channel_id, data }) => {
  let finalUrl = `/channel/${channel_code}/product/cmd/${channel_id}/mapping`
  let finalMethod = 'post'
  let finalData = data
  const { status, ...rest } = data
  if (['shopee', 'shopee_id'].includes(channel_code)) {
    if (status === 'UNCONFIRMED') {
      finalUrl = `/channel/shopee/v2/product/cmd/${channel_id}/unmap`
    } else {
      finalUrl = `/channel/shopee/v2/product/cmd/${channel_id}/map`
    }
    finalData = rest
  } else if (['zalora_id', 'zalora'].includes(channel_code)) {
    if (status === 'UNCONFIRMED') {
      finalUrl = `/channel/${channel_code}/product/cmd/${channel_id}/unmap`
      finalMethod = 'put'
    }
    finalData = rest
  } else if (['toco', 'toco_id'].includes(channel_code)) {
    if (status === 'UNCONFIRMED') {
      finalUrl = `/channel/toco/product/cmd/${channel_id}/unmap`
    } else {
      finalUrl = `/channel/toco/product/cmd/${channel_id}/map`
    }
    finalData = rest
  }
  return apiClient({
    method: finalMethod,
    url: finalUrl,
    headers: {
      'Business-Id': business_id,
    },
    data: finalData,
    notifications: true,
  })
}

export const importProductChannel = ({ is_single, business_id, channel_code, channel_id, data }) => {
  let url;
  if (channel_code.includes('blibli')) {
    url = `/channel/blibli/product/cmd/import/${is_single}master/product`;
  } else if (['tiktok', 'tiktok_id'].includes(channel_code)) {
    url = `/channel/${channel_code}/product/cmd/import/master/${channel_id}`;
  } else if (['shopee', 'shopee_id'].includes(channel_code)) {
    url = `/channel/shopee/v2/product/cmd/import/master/${channel_id}`;
  } else if (['toco', 'toco_id'].includes(channel_code)) {
    url = `/channel/toco/product/cmd/import/master/${channel_id}`;
  } else {
    url = `/channel/${channel_code}/product/cmd/${channel_id}/import/master/product`;
  }

  return apiClient({
    method: 'post',
    url,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const getShopeeImportProductStatus = ({ business_id, channel_id, request_id, product_ids }) => {
  const requestIdPath = request_id ? `/${request_id}` : ''
  return apiClient({
    method: 'get',
    url: `/channel/shopee/v2/product/query/${channel_id}/import/status${requestIdPath}`,
    headers: {
      'Business-Id': business_id,
    },
    params: {
      product_ids,
    },
  })
}

export const channelProductDraft = ({ business_id, channel_code, channel_id, user_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `/channel/${channelPath}/product/cmd/${channel_id}/${user_id}/draft`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const uploadChannelImage = ({ business_id, channel_code, channel_id, user_id, product_id, file, image_type }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  const isShopee = channelPath === 'shopee/v2'
  const id = isShopee ? '' : `/${product_id}`
  const params = isShopee || channel_code.includes('tokopedia') || channel_code.includes('toco_id') ? { image_type } : undefined
  const form = new FormData()
  form.append('image', file)

  return apiClient({
    method: 'post',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/${channel_id}/${user_id}/upload/image`
      : `/channel/${channelPath}/product/cmd/${channel_id}/${user_id}/upload/image${id}`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Business-Id': business_id,
    },
    data: form,
    params,
  })
}

export const addDeleteImages = ({ type = undefined, business_id, channel_id, product_id, file, images_existing }) => {
  const form = new FormData()
  if (type) {
    if (images_existing.length) form.append('images_existing', images_existing.join(','))
    file.forEach(item => form.append('images', item))
  } else {
    form.append('images', file)
    form.append('images_existing', images_existing)
  }

  form.append('business_id', business_id)
  form.append('product_id', product_id)

  return apiClient({
    method: 'post',
    url: `/channel/distributor/product/cmd/${channel_id}/add-delete-images`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Business-Id': business_id,
    },
    data: form,
    params: { business_id },
  })
}

export const addChannelProduct = ({ method = 'post', business_id, channel_code, channel_id, user_id, product_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  const isShopee = channelPath === 'shopee/v2'
  const create = isShopee || channel_code.includes('tiktok') ? 'create/' : ''
  return apiClient({
    method,
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/create/${channel_id}/${user_id}/${product_id}`
      : `/channel/${channelPath}/product/cmd/${create + channel_id}/${user_id}/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const getChannelDraft = ({ business_id, channel_code, channel_id, user_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: ['shopee', 'shopee_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/${channel_id}/${user_id}/draft/`
      : `/channel/${channelPath}/product/cmd/${channel_id}/${user_id}/draft/`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const syncChannelAttributes = ({ business_id, channel_code, channel_id, path, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/${channel_id}/import/${path}`
      : `/channel/${channelPath}/product/cmd/${channel_id}/import/${path}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const onSyncOrderChannel = async ({ business_id, channel_code, channel_id, payload }) => {
  if (['shopee_id'].includes(channel_code)) {
    return apiClient({
      method: 'post',
      url: `/channel/shopee/v2/order/cmd/${channel_id}/synchronize/order`,
      data: payload,
      headers: {
        'Business-Id': business_id,
      },
    })
  } else if (['tokopedia_id', 'tiktok'].includes(channel_code)) {
    return apiClient({
      method: 'post',
      url: `/channel/${channel_code}/order/cmd/${channel_id}/orders/sync`,
      data: payload,
      headers: {
        'Business-Id': business_id,
      },
    })
  } else if (['lazada_id'].includes(channel_code)) {
    return apiClient({
      method: 'post',
      url: `/channel/${channel_code}/order/${channel_id}/synchronize`,
      data: payload,
      headers: {
        'Business-Id': business_id,
      },
    })
  } else {
    return false
  }
}

export const acceptFulfillmentOrder = ({ channel_code, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `/channel/${channelPath}/order/cmd/accept`,
    data,
  })
}

export const cancelFulfillmentOrder = ({ business_id, channel_code, channel_id, order_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `/channel/${channelPath}/order/cmd/${channel_id}/${order_id}/cancel`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const connectedChannel = ({ channel_code, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `channel/${channelPath}/integration/cmd/connect`,
    data,
  })
}

export const addNewSku = ({ channel_code, channel_id, data }) => {
  return apiClient({
    method: 'post',
    url: `channel/${channel_code}/${channel_id}/catalog/sku`,
    data,
  })
}

export const disconnectChannelWithPause = ({ business_id, channel_code, channel_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? '/channel/toco/integration/cmd/disconnect'
      : `/channel/${channelPath}/integration/cmd/disconnect`,
    params: {
      channel_id,
    },
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const reconnectChannelWithPause = ({ business_id, channel_code, channel_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? '/channel/toco/integration/cmd/reconnect'
      : `/channel/${channelPath}/integration/cmd/reconnect`,
    params: {
      channel_id,
    },
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const activateDeactivateProductChannel = ({ business_id, channel_code, channel_id, user_id, product_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `channel/toco/product/cmd/edit/${channel_id}/${user_id}/${product_id}`
      : `channel/${channelPath}/product/cmd/edit/${channel_id}/${user_id}/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateProductChannel = ({ business_id, channel_code, channel_id, user_id, product_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/edit/${channel_id}/${user_id}/${product_id}`
      : `/channel/${channelPath}/product/cmd${['tiktok', 'tiktok_id'].includes(channel_code) ? '' : '/edit'}/${channel_id}/${user_id}/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateProductChannelStatus = ({ method, business_id, channel_code, channel_id, status, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method,
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/${channel_id}/${status}`
      : `/channel/${channelPath}/product/cmd/${channel_id}/${status}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const processingOrder = ({ business_id, processType, id, channel_id, channel_code, order_number, ...data }) => {
  let method, url, requestData, params;

  if (channel_code === 'blibli_id') {
    method = 'post';
    url = `channel/blibli/order/cmd/accept/single/${channel_id}`;
    requestData = { order_id: id };
    params = undefined;
  } else if (['tiktok', 'tiktok_id', 'zalora', 'zalora_id', 'tiktok_tokopedia'].includes(channel_code)) {
    method = 'put';
    let finalChannelCode = channel_code
    if (finalChannelCode === 'tiktok_tokopedia') {
      finalChannelCode = 'tiktok';
    }
    url = `/channel/${finalChannelCode}/order/cmd/state/accept`;
    params = { id, channel_id };
  } else if (channel_code === 'shopee_id') {
    method = 'put';
    url = `/channel/shopee/v2/order/cmd/${processType}`;
    requestData = data;
    params = { business_id, id, order_number };
  } else {
    method = 'put';
    url = `/channel/${channel_code}/order/cmd/${processType}`;
    requestData = data;

    if (channel_code === 'lazada_id') {
      params = { order_id: id };
    } else {
      params = { business_id, id, order_number };
    }
  }

  return apiClient({
    method,
    url,
    headers: {
      'Business-Id': business_id,
    },
    data: requestData,
    params,
  })
}

export const processingOrderState = ({ business_id, order_id, data, order_number }) => {
  return apiClient({
    method: 'put',
    url: `/sales-manual/state?order_number=${order_number}&id=${order_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const b2cProcessingOrderCancel = ({ business_id, data, params }) => {
  return apiClientAdm({
    method: 'put',
    url: `/apinit/order/cmd/cancel`,
    headers: {
      'Business-Id': business_id,
    },
    data,
    params,
  })
}

export const cancelOrderState = ({ business_id, order_id, data, order_number }) => {
  return apiClient({
    method: 'put',
    url: `/sales-manual/cancel?order_number=${order_number}&id=${order_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const resynchronizeOrder = ({ business_id, channel_code, order_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'patch',
    url: `/channel/${channelPath}/order/cmd/orders/${order_id}/sync-booking-number`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const deleteChannelDraft = async ({ business_id, channel_code, channel_id, user_id, product_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  await apiClient({
    method: 'delete',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/product/cmd/${channel_id}/${user_id}/draft/${product_id}`
      : `/channel/${channelPath}/product/cmd/${channel_id}/${user_id}/draft/${product_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const internalCancelOrderState = ({ business_id, data }) => {
  return apiOpenClient({
    method: 'post',
    url: `/internal/canceled`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const disconnecMappingWarehouseChannel = ({ business_id, channel_code, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'delete',
    url: `/channel/${channelPath}/integration/cmd/warehouse/map`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const connectMappingWarehouseChannel = ({ business_id, channel_code, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `/channel/${channelPath}/integration/cmd/warehouse/map/multi`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateMappingWarehouseChannel = ({ business_id, channel_code, mapping_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: `/channel/${channelPath}/integration/cmd/warehouse/map/${mapping_id}`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateAutoAcceptChannel = ({ business_id, channel_code, channel_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco-id'].includes(channel_code)
      ? `/toco-main/integration/${channel_id}/data`
      : `/channel/${channelPath}/integration/${channel_id}/data`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const updateAutoAcceptPerWarehouse = ({ business_id, channel_code, channel_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'post',
    url: `/channel/${channelPath}/integration/cmd/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const getDetailChannel = ({ business_id, channel_code, channel_id }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'get',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/toco-main/integration/${channel_id}`
      : `/channel/${channelPath}/integration/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const updateDataDetailChannel = ({ business_id, channel_code, channel_id, data }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  return apiClient({
    method: 'put',
    url: ['toco', 'toco_id'].includes(channel_code)
      ? `/channel/toco/integration/cmd/${channel_id}/data`
      : `/channel/${channelPath}/integration/cmd/${channel_id}/data`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}


export const getChannelListInventoryPerWarehouse = ({ channel_code, channel_id, business_id, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'

  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/mp-product/info`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getChannelListHistoryStockProduct = ({ channel_code, channel_id, business_id, params }) => {
  let channelPath = channel_code
  if (['shopee', 'shopee_id'].includes(channel_code)) channelPath = 'shopee/v2'
  if (['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(channel_code)) channelPath = 'tiktok'

  return apiClient({
    method: 'get',
    url: `/channel/${channelPath}/product/query/${channel_id}/history/stock`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}